import {
  ProjectMember,
  ProjectPermission,
} from '@ih/app/shared/apis/interfaces';

export class SetProjectPermissionsAction {
  public static readonly type = '[Authorisation] SetProjectPermissionsAction';
  constructor(
    public readonly projectMembers: ProjectMember[],
    public readonly permissions: ProjectPermission[],
  ) {}
}
